<template>
    <v-flex xs12>
      <v-card>
        <v-flex xs12 pt-4 px-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-form>
          <v-layout row wrap align-center justify-space-between class="px-3 pt-3 pb-0">
            <v-flex xs12 sm6 md6>
              <v-layout row wrap>
                <datetime 
                  :phrases="{ ok: $lang.actions.ok, cancel: $lang.actions.cancel}"
                  v-model="fromDate"
                  type="datetime"
                  :placeholder="$lang.labels.fromDate"
                  class="datetime-btn primary--text mx-2" 
                />
                <datetime
                  :phrases="{ ok: $lang.actions.ok, cancel: $lang.actions.cancel}" 
                  v-model="toDate" 
                  type="datetime" 
                  :placeholder="$lang.labels.toDate" 
                  class="datetime-btn primary--text mx-2" 
                /> 
              </v-layout>
            </v-flex>
            <v-flex xs12 sm6 md3 px-2>
              <v-select
                class="min-w max-w"
                chips
                deletable-chips
                hide-details
                multiple
                :items="statuses"
                v-model="selectedStatuses"
                :label="$lang.labels.status"
              />
            </v-flex>
            <v-flex xs12 md3 px-2 class="text-xs-left text-md-right">
              <v-btn
                class="primary mx-0"
                @click="showDetails()"
              >{{$lang.actions.showDetails}}</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
        <div v-if="true">
          <v-card-title class="pb-0 px-4 layout row wrap">
            <v-spacer></v-spacer>
            <v-text-field
              class="min-w max-w"
              v-model="search"
              append-icon="search"
              :label="$lang.labels.search"
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="orders"
            :search="search"
            :loading="ordersLoading"
            :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
          >
            <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
            <template slot="items" slot-scope="props">
              <td>
                <v-btn flat class="primary--text ma-0" @click="showModal(props.item.webShopOrderId)">
                  {{ props.item.webShopOrderId }}
                </v-btn>
                <div class="d-block" style="padding: 0 16px;">{{props.item.webShopOrderSourceSystem}}</div> 
              </td>
              <td>{{ props.item.orderId }}</td>
              <td>{{ parseFloat(props.item.totalAmount).toFixed(2) }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.name }}</td>
              <td>
                {{ props.item.email }}
                <div class="d-block mt-1">{{ props.item.phone }}</div>
              </td>
              <td>{{ formatDate(props.item.createdOn) }}</td>
            </template>
            <v-alert slot="no-results" :value="true" color="warning" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
        </div>
        <v-btn 
          absolute
          flat class="ml-0 close-btn" 
          @click="$router.push({ name: 'webShop' })">
          <v-icon>keyboard_arrow_left</v-icon>
          {{$lang.actions.close}}
        </v-btn>
      </v-card>
      <v-dialog v-if="lastOrderModal" v-model="lastOrderModal" max-width="1200">
        <last-order-modal :lastOrder="lastOrder" @close="lastOrderModal = false"/>
      </v-dialog>
    </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    components: {
      lastOrderModal: () => import('../modals/LastOrderModal'),
    },
    data() {
      return {
        err: '',
        search: '',
        fromDate: DateTime.local().minus({ hours: 12 }).toISO(),
        toDate: DateTime.local().plus({ hours: 4 }).toISO(),
        statuses: ['pending', 'complete'],
        selectedStatuses: ['pending'],
        ordersLoading: false,
        lastOrderModal: false,
        lastOrder: null,
        orders: [],
        headers: [
          { text: this.$lang.header.orderIdSource, value: 'webShopOrderId', align: 'left', sortable: false },
          { text: this.$lang.header.orderCode, value: 'orderId', align: 'left', sortable: false },
          { text: this.$lang.labels.totalAmount, value: 'totalAmoun', align: 'left', sortable: false },
          { text: this.$lang.labels.status, value: 'status', align: 'left', sortable: false },
          { text: this.$lang.header.customerName, value: 'name', align: 'left', sortable: false },
          { text: this.$lang.header.emailPhone, value: 'email', align: 'left', sortable: false },
          { text: this.$lang.labels.created, value: 'createdOn', align: 'left', sortable: false },
        ],
      };
    },
    methods: {
      showModal(orderId) {
        this.lastOrder = {
          id: orderId
        }
        this.lastOrderModal = true;
      },
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm');
      },
      showDetails() {
        this.ordersLoading = true;
        this.orders = [];
        const data = {};
        if (this.selectedStatuses.length > 0) {
          data.statuses = this.selectedStatuses;
        }
        if (this.fromDate) {
          data.fromDate = this.fromDate;
        }
        if (this.toDate) {
          data.toDate = this.toDate;
        }
        this.$http.post(`webshoporder/getallforwebshopresource/${this.$route.params.id}`, data)
          .then((res) => {
            this.ordersLoading = false;
            if (res.body.status === 'Success') {
              this.orders = res.body.orders;
              return;
            }
            this.err = res.body.statusText;
          })
          .catch((err) => {
            this.ordersLoading = false;
            this.err = err.body.statusText || err.body.message;
          });
      },
    },
    created() {
      this.showDetails();
    },
  };
</script>
<style lang="scss" scoped>
  .close-btn {
    left: 24px;
    bottom: 6px;
  }
</style>



// WEBPACK FOOTER //
// WebShopOrder.vue?5e08aeba